import React from 'react'
import css from './style.css'
import LoggedOut from '../logged-out'
import LoginForm from './form'
import Header from '../../components/header'
import Spacer from '../../components/spacer'
import { baseUrl } from '../../api'

const resetPasswordUrl = `${baseUrl}/users/password/new`

const Login = props => (
  <LoggedOut>
    <Header>Login</Header>
    <Spacer xxs />
    <LoginForm />
    <Spacer xxs />
    <div className={css.forgot}>
      <a href={resetPasswordUrl}>Forgot password?</a>
    </div>
  </LoggedOut>
)

export default Login



// WEBPACK FOOTER //
// ./src/containers/login/index.js